import React, { useEffect, useMemo, useParams, useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Box, IconButton, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import { Card, Button, Stack } from "@mui/material";
import MDTypography from "components/MDTypography";
import AppLoading from "verticales/AppLoading.tsx";
import TableMaestroDeep from "../../../verticales/TableMaestrosDepp.tsx";
import fetchData from "verticales/FetchData";
import MDButton from "components/MDButton";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "deep-client";
const View = (props: any) => {
  //console.log("Hola, estos son tus props...", props);
  const [blocking, setBlocking] = useState(false);
  const [data, setData] = useState([]);
  const strTitleBusqueda =
    "Resultado de la busqueda " + props?.row?.datoBusqueda ?? "none3asdfnohayguajirapirukaa";
  useEffect(() => {
    busquedaDatosCliente(props?.row?.datoBusqueda ?? "none3asdfnohayguajirapirukaa");
    // busquedaDatosCliente(datosBusqueda);
  }, []);

  const busquedaDatosCliente = async (datoBusqueda) => {
    console.log("apsosss!!!...............", datoBusqueda);
    const params = {
      action: "get-clientes",
      params: {
        datoBusqueda,
      },
    };
    setBlocking(true);
    try {
      const resp = await fetchData(url, context, params);
      // console.log("Data cliente...", resp.rows);
      setData(resp.rows);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setData([]);
    } finally {
      setBlocking(false);
    }
  };

  const columns = useMemo(
    () => [
      { header: "database", accessorKey: "name_database" },
      { header: "companias", accessorKey: "companias" },
      { header: "nro_cia_activas", accessorKey: "nro_cia_activas" },
      { header: "storage", accessorKey: "tamano" },
      { header: "estado", accessorKey: "estado" },
      { header: "rds_id", accessorKey: "rds_id" },
      { header: "repeticion", accessorKey: "repeticion" },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
        <Tooltip title="Ver">
          <IconButton onClick={() => props.handleCloseModal(row)}>
            {/* <IconButton> */}
            <AnalyticsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <MDTypography variant="h4" color="white">
                  {strTitleBusqueda}
                </MDTypography>
                {/* <h1>hola como estas!!!</h1> */}
              </MDBox>
              {blocking ? (
                <AppLoading titleCustom={"deep-clientes"} />
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox m={1}>
                    <TableMaestroDeep
                      arrayColumns={columns}
                      data={data}
                      // handleOpenModal={handleOpenModal}
                      height={250}
                      renderOpcRows={renderOpcRowsSid}
                    />
                    <Stack justifyContent="right" direction="row" sx={{ p: 1 }}>
                      <MDButton disableElevation onClick={props.handleCloseModal}>
                        <MDTypography>Cerrar</MDTypography>
                      </MDButton>
                    </Stack>
                  </MDBox>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default View;
